import React from 'react'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function ServiceDetail1() {
     const clients = [
          {
               img: "/assets/services/embossing.svg",
               title: "Embossing Service – Stainless Steel Tags",
               text: "Durable, corrosion-resistant tags ideal for long-term industrial labeling.",
               link: "/services/embossing-service"
          },
          {
               img: "/assets/services/laser-marking.svg",
               title: "Laser Marking Service (except aluminium metal)",
               text: "High-precision, permanent laser engraving for sharp, clear identification.",
               link: "/services/laser-marking"
          },
          {
               img: "/assets/services/engraved-tags.svg",
               title: "Engraved Tags – Stainless Steel, Aluminium",
               text: "Customized, deep-engraved tags for robust and lasting identification.",
               link: "/services/engraved-tags"
          },
          {
               img: "/assets/services/thermal-printed-cable-tags.svg",
               title: "Thermal Printed Cable Tags (Yellow/White/Blue/Red)",
               text: "Color-coded tags for quick, clear, and organized cable identification.",
               link: "/services/thermal-printed-cable-tags"
          },
          {
               img: "/assets/services/shrinkable-markers.svg",
               title: "Shrinkable Cable & Wire Markers",
               text: "Heat-shrink markers that securely label wires and cables under stress.",
               link: "/services/shrinkable-cable-markers"
          },
          {
               img: "/assets/services/self-laminating-labels.svg",
               title: "Self-Laminating Labels",
               text: "Writable labels with protective overlay for clarity and durability.",
               link: "/services/self-laminating-labels"
          },
          {
               img: "/assets/services/pipe-markers.svg",
               title: "Pipe Markers",
               text: "Identify contents and flow direction for safety and compliance.",
               link: "/services/pipe-markers"
          },
          {
               img: "/assets/services/duct-markers.svg",
               title: "Duct Markers",
               text: "Clear duct labeling for HVAC, cabling, or utility routing systems.",
               link: "/services/duct-markers"
          },
          {
               img: "/assets/services/high-temp-markers.svg",
               title: "High Temperature Stainless Steel Markers",
               text: "Designed to withstand extreme heat in industrial applications.",
               link: "/services/high-temp-stainless-markers"
          },
          {
               img: "/assets/services/valve-tags.svg",
               title: "Valve Tags",
               text: "Tag and track valve operations for safety and process control.",
               link: "/services/valve-tags"
          },
          {
               img: "/assets/services/equipment-tags.svg",
               title: "Equipment Tags",
               text: "Durable tags for equipment identification and maintenance records.",
               link: "/services/equipment-tags"
          },
          {
               img: "/assets/services/accident-prevention-tags.svg",
               title: "Accident Prevention Tags",
               text: "Warning tags to promote workplace safety and hazard awareness.",
               link: "/services/accident-prevention-tags"
          },
          {
               img: "/assets/services/warning-tapes.svg",
               title: "Warning Tapes – Detectable & Non-Detectable",
               text: "Ground marking tapes for cable routes, hazards, and utilities.",
               link: "/services/warning-tapes"
          },
          {
               img: "/assets/services/rotary-switch-plates.svg",
               title: "Rotary Switch Plates",
               text: "Custom plates for switchgear with clear position marking.",
               link: "/services/rotary-switch-plates"
          },
          {
               img: "/assets/services/cable-tray-markers.svg",
               title: "Cable Tray Markers",
               text: "Organized identification for cable tray runs and pathways.",
               link: "/services/cable-tray-markers"
          }
     ];

     return (
          <>
          <Helmet>
    <title>
        Cable Termination Support & Services UAE | Al Ibtekar
    </title>

    <meta
        name="description"
        content="Al Ibtekar provides professional cable termination support and services in the UAE, including cable cutting, preparation, stripping, crimping, tool selection, crimp data analysis, tool calibration, field engineer training and workshop setup."
    />

    <meta
        name="keywords"
        content="cable termination services UAE, cable termination support UAE, cable crimping UAE, cable cutting services UAE, cable stripping services UAE, crimping tools UAE, cable termination tools UAE, cable lug crimping UAE, cable termination training UAE, cable tool calibration UAE"
    />

    <link
        rel="canonical"
        href="https://saig.me/cable-termination"
    />

    <meta
        property="og:title"
        content="Cable Termination Support & Services UAE | Al Ibtekar"
    />

    <meta
        property="og:description"
        content="Professional cable termination support including cable preparation, stripping, crimping, tool selection, calibration, training and on-site demonstrations across the UAE."
    />

    <meta
        property="og:url"
        content="https://saig.me/cable-termination"
    />

    <meta
        property="og:type"
        content="website"
    />
</Helmet>
               <div className='newbanner-about newbanner-about2'>
                    <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                         <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Cable Termination - Support & Services</h6>
                         {/* <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Industrial Labeling & Tagging Solutions
                         </p> */}
                    </div>
               </div>
               {/* <div className="mt-[91px] overflow-hidden relative">
                    <img src="/assets/product/bg1.png" className='w-full lg:h-auto h-[300px] object-cover' alt="	Trusted cable management and termination solutions provider in the UAE" />
                    <div className="absolute lg:top-[125px] top-[20px] max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] left-1/2 -translate-x-1/2">
                         <h6 className="font-[500] font-kanit lg:text-[70px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Cable Termination - Support & Services</h6>
                         <p className="max-w-[582px] w-full font-[300] font-inter lg:text-[20px] text-[14px] lg:leading-[30px] leading-[20px] text-[#FFFFFF]">Industrial Labeling & Tagging Solutions</p>
                    </div>
                    <h1 className='absolute font-[600] font-kanit lg:text-[180px] text-[60px] lg:leading-[180px] leading-[70px] text-[#FFFFFF4F] right-[0px] lg:bottom-[86px] bottom-[40px]'>Termination</h1>
               </div> */}
               <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  <h2>Cable Termination - Support & Services</h2>
  <div className='line'></div>
                         <h3 className='text-justify'>An incorrect crimp results in an energy loss in between 5% to 20% and further may cause
fire hazard or complete system failure.

Our product specialist has undergone extensive training at Cembre, Italy and are locally
available to guide and support on critical crimp. Our product specialist is equipped with a
range of tools – hardware’s &amp; software’s, while offering the following services. </h3>

               </div>
               </div>

              <div className='service-details-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]'>

                    <div className='service-details-div-left'>
                         <img src='/assets/newsr5.png' className='lg:h-[700px] h-auto object-cover' alt='' />
                    </div>
                    <div className='service-details-div-right font-kanit'>
                        
<ul className="mt-4 grid grid-cols-1 md:grid-cols-1">
  {[
    "Product selection",
    "Cable cutting and preparation",
    "Cutting tool selection and recommendation",
    "Stripping tool selection and recommendation",
    "Crimping tool & die selection and recommendation",
    "Complimentary, on-site demonstration and crimping",
    "Crimp data storage and analysis",
    "Purchase of new tools",
    "Issue of complimentary tool whilst the client tool is under repair",
    "Calibration of tools",
    "Training of field engineers",
    "Set up of workshop",
  ].map((item, i) => (
    <li
      key={i}
      className="flex items-start gap-3 rounded-lg bg-white px-4transition"
    >
      <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
      <span className="text-gray-700 text-[18px] leading-relaxed aplus">
        {item}
      </span>
    </li>
  ))}
</ul>



                    <Link to='/services'>

            <button className='backbtn'>
              Back To Services
            </button>
</Link>
                    </div>

                  
               </div>

               {/* <div className='service-details-div2 font-kanit max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden'>
                    <h3>Product & Service List with Descriptions</h3>
                    <div className='grid lg:grid-cols-4 grid-cols-1 gap-[30px] lg:pt-[60px] pt-[40px]'>

                         <div className='ser-box'>

                              <h4>Embossing Service – Stainless Steel Tags</h4>

                              <p>Durable, corrosion-resistant tags ideal for long-term industrial labeling.</p>
                         </div>
                         <div className='ser-box'>

                              <h4>Laser Marking Service (except aluminium metal)</h4>

                              <p>High-precision, permanent laser engraving for sharp, clear identification.</p>
                         </div>
                         <div className='ser-box'>

                              <h4>Engraved Tags – Stainless Steel, Aluminium</h4>


                              <p>Customized, deep-engraved tags for robust and lasting identification.</p>

                         </div>
                         <div className='ser-box'>

                              <h4>Thermal Printed Cable Tags (Yellow/White/Blue/Red)</h4>
                              <p>Color-coded tags for quick, clear, and organized cable identification.</p>
                         </div>
                         <div className='ser-box'>

                              <h4>Shrinkable Cable & Wire Markers</h4>
                              <p>Heat-shrink markers that securely label wires and cables under stress.</p>
                         </div>
                         <div className='ser-box'>

                              <h4>Self-Laminating Labels</h4>
                              <p>Writable labels with protective overlay for clarity and durability.</p>
                         </div>
                         <div className='ser-box'>

                              <h4>Pipe Markers</h4>
                              <p>Identify contents and flow direction for safety and compliance.

                              </p>

                         </div>

                         <div className='ser-box'>

                              <h4>Duct Markers</h4>
                              <p>Clear duct labeling for HVAC, cabling, or utility routing systems.

                              </p>
                         </div>

                         <div className='ser-box'>

                              <h4>High Temperature Stainless Steel Markers</h4>
                              <p>Designed to withstand extreme heat in industrial applications.

                              </p>
                         </div>
                         <div className='ser-box'>


                              <h4>Valve Tags</h4>
                              <p>Tag and track valve operations for safety and process control.


                              </p>
                         </div>

                         <div className='ser-box'>

                              <h4>Equipment Tags</h4>
                              <p>Durable tags for equipment identification and maintenance records.
                              </p>
                         </div>
                         <div className='ser-box'>

                              <h4>Accident Prevention Tags</h4>
                              <p>Warning tags to promote workplace safety and hazard awareness.</p>
                         </div>
                         <div className='ser-box'>

                              <h4>Warning Tapes – Detectable & Non-Detectable</h4>
                              <p>Ground marking tapes for cable routes, hazards, and utilities.
                              </p>
                         </div>
                         <div className='ser-box'>

                              <h4>Rotary Switch Plates</h4>
                              <p>Custom plates for switchgear with clear position marking.
                              </p>
                         </div>

                         <div className='ser-box'>

                              <h4>Cable Tray Markers</h4>
                              <p>Organized identification for cable tray runs and pathways.
                              </p>
                         </div>
                    </div>



               </div> */}
               <br />
               <br />
               {/* <section className="bg-[#fff] dark:bg-[#FBB210] py-[60px] md:py-[50px]">
                <div className="max-w-[1200px] flex flex-col lg:flex-row justify-between items-start mx-auto w-full gap-[40px] lg:px-[12px] px-[20px]">
                    <div className="lg:max-w-[480px] max-w-[100%] w-full text-[#000] dark:text-[#000000] lg:sticky lg:top-[150px] self-start">
                        <h6 data-aos="fade-right" className="text-[28px] lg:text-[48px] font-outfit font-[400] mb-[24px] leading-[40px] lg:leading-[56px]">
                            Product & Service List with Descriptions
                        </h6>
                        <p className="font-outfit text-[16px] font-[400] leading-[24px] mb-[20px] md:mb-[36px]">
                            Trusted Solutions. Tailored Excellence.
At Al Ibtekar, we go beyond... across industrial, automation, solar and oil & gas sectors
                        </p>
                        <div className="group inline-flex items-center cursor-pointer">
                            <i className="bi bi-arrow-right text-[#fff] text-[40px] transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                        </div>

                    </div>
                    <div className="lg:max-w-[600px] max-w-[100%] w-full">
                        <div className="grid gap-[20px]">
                            {clients.map((item, index) => (
                                <div key={index}>
                                    <div
                                        className="nsr border group relative rounded-[8px]  backdrop-blur-[10px] p-[15px] md:p-[20px] pr-[60px] md:pr-[74px] transition-transform duration-300 transform hover:scale-[1.03] hover:shadow-lg"
                                        style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}
                                    >
                                        <div className="flex flex-col sm:flex-row gap-[15px] md:gap-[30px] items-start">
                                          
                                            <div className='text-[#000] dark:text-[#000000]'>
                                                <h6 className="text-[20px] font-outfit md:text-[24px] lg:text-[26px] font-[500] mb-[15px] md:mb-[25px] dark:text-[#000] dark:group-hover:text-white">                                                    {item.title}
                                                </h6>
                                                <p className="text-[14px] font-outfit font-[400] leading-[20px] dark:text-[#000] dark:group-hover:text-white">
                                                    {item.text}
                                                </p>
                                           
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section> */}

          </>
     )
}

export default ServiceDetail1